import Header from "../../../components/header";
import LeftMenu from "../../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "../../PIList/api.js";
import {readEmpty} from "../../PIList/apiEmpty.js";
import Post from "../../PIList/Post.jsx";
import {useNavigate, useLocation} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { HouseboatOutlined } from "@mui/icons-material";
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Divider from '@mui/material/Divider';
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4VO from "./Step4VO";
import Step4PO from "./Step4PO";
import Step4CallCenter from "./Step4CallCenter";
import Step5CallCenter from "./Step5CallCenter";
import Step5VO from "./Step5VO";
import Step5PO from "./Step5PO";
import Step5VOTemp from "./Step5VOTemp";
import Edit from "./Edit"
import ExtendVO from "./ExtendVO"
import ExtendPO from "./ExtendPO"
import EditPO from "./EditPO"
import EditCallCenter from "./EditCallCenter"
import ExtendCallCenter from "./ExtendCallCenter"




const Mastertemplate = props => {

  const passed = useLocation();

    
  ///////Variable to Pass On to Contract Generator machine//////////
  const [sellerData,setSellerData] = useState([
    {namaPerusahaan:"PT. Supardi Nethanel Husain", alamat:"", nomorTelepon:""},
]);
const [currentStep,setCurrentStep] = useState(1)

const [progressTracker, setProgressTracker] = useState(0)

const [selectedPost, setSelectedPost] = useState(null);

useEffect(()=>{
  if(passed.state.stuff === "edit"){
  
    console.log("editmode")
    setStatusEdit("Edit Kontrak")
    console.log(passed)
    setSelectedType(passed.state.data.TipeKontrak)
    setklienID(passed.state.data.KlienID)
    setcompanyID(passed.state.data.CompanyID)
  }else{}
})

/////End Variable to Pass on to contract generator machine////////

///////Functions for Seller Company///////////////////////////////
const handleSellerCompany = (event) => {
    console.log(event)
    const values =[...sellerData];
    values.namaPerusahaan = event.target.value;
    setSellerData(values)
};
///////End of Functions for Seller Company///////////////////////////////
///////Progress Bar Function/////////////////////////////////////////////
    function LinearProgressWithLabel(props) {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2" color="text.secondary">{`${Math.round(
                props.value,
              )}%`}</Typography>
            </Box>
          </Box>
        );
      }
///////End of Progress Bar Function////////////////////////////////////
//////Prev, Next, Submit Button Functions/////////////////////////////

function nextButton(post){
  if (currentStep !== 5) {
    setProgressTracker(((currentStep)/5)*100)
    setCurrentStep(currentStep+1)
    console.log(post)
    setSelectedPost(post);
  }else{}
}
const [statusEdit, setStatusEdit] = useState("Pembuatan Kontrak");
const [selectedType, setSelectedType] = useState();
const [klienID, setklienID] = useState(null);
const [companyID, setcompanyID] = useState(null)
function prevButton(){
  if (currentStep !== 1) {
    setProgressTracker(((currentStep-2)/5)*100)
    setCurrentStep(currentStep-1)
  }else{}
}
////////End Prev,Next, Submit Button Functions//////////////////////
//////////Start Date Picker Function////////////////////////////////
const [bDate,setbDate] = useState(Date())
const handleDateChange = (event) => {
  setbDate(event);
  console.log(event)
}
//////////Start Date Picker Function////////////////////////////////
const [contractData, setContractData] = useState(passed.state.data);  // Added this line


    return ( <Grid container sx={{ pl:15}} md={12} display="inline-block">
          {passed.state.stuff === "" && (
      <Box sx={{ width: '100%' }}>
          <LinearProgressWithLabel value={progressTracker} />
      </Box>   
          )}                 
      <Grid md={12} sx={{mb:5}}>
          <b>{statusEdit}</b>                       
      </Grid>
      {passed.state.stuff === "edit" && passed.state.data.TipeKontrak === "Virtual Office" && (
        <Edit contractData={contractData} setContractData={setContractData} passed={passed}></Edit>
      )}
      {passed.state.stuff === "extend" && passed.state.data.TipeKontrak === "Virtual Office" && (
        <ExtendVO contractData={contractData} setContractData={setContractData} passed={passed}></ExtendVO>
      )}
      {passed.state.stuff === "extend" && passed.state.data.TipeKontrak === "Private Office" && (
        <ExtendPO contractData={contractData} setContractData={setContractData} passed={passed}></ExtendPO>
      )}
      {passed.state.stuff === "edit" && passed.state.data.TipeKontrak === "Private Office" && (
        <EditPO contractData={contractData} setContractData={setContractData} passed={passed}></EditPO>
      )}
      {passed.state.stuff === "edit" && passed.state.data.TipeKontrak === "Call Center" && (
        <EditCallCenter contractData={contractData} setContractData={setContractData} passed={passed}></EditCallCenter>
      )}
      {passed.state.stuff === "extend" && passed.state.data.TipeKontrak === "Call Center" && (
        <ExtendCallCenter contractData={contractData} setContractData={setContractData} passed={passed}></ExtendCallCenter>
      )}
      {passed.state.stuff === "new" && (
      <Paper sx={{p:5, boxShadow:10}} md={12}>
          <Step1 sellerData={sellerData} nextButton={nextButton} currentStep={currentStep} companyID={companyID} handleSellerCompany={handleSellerCompany} setklienID={setklienID} setcompanyID={setcompanyID}></Step1>
          <Step2 sellerData={sellerData} setSelectedType={setSelectedType} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step2>
          <Step3 sellerData={sellerData} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost}></Step3>
          <Step4VO sellerData={sellerData} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step4VO>
          <Step4PO sellerData={sellerData} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step4PO>
          <Step4CallCenter setCurrentStep={setCurrentStep} sellerData={sellerData} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step4CallCenter>
          <Step5PO sellerData={sellerData} selectedType={selectedType} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step5PO>
          <Step5VO sellerData={sellerData} selectedType={selectedType} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step5VO>
          <Step5CallCenter sellerData={sellerData} selectedType={selectedType} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step5CallCenter>
          <Step5VOTemp sellerData={sellerData} selectedType={selectedType} handleDateChange={handleDateChange} prevButton={prevButton} bDate={bDate} nextButton={nextButton} currentStep={currentStep} handleSellerCompany={handleSellerCompany} selectedPost={selectedPost} klienID={klienID} companyID={companyID}></Step5VOTemp>

      </Paper>
      )}


  </Grid>
  );
};

    export default Mastertemplate;
